import EntriesControls from './EntriesControls';
export default EntriesControls;